export default __webpack_public_path__ + "static/media/icone-tiktok.d40664cf.svg";